var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerGameTypeTotalKo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 3.785a8.249 8.249 0 017.464 7.465H21v1.5h-.786a8.248 8.248 0 01-7.464 7.464V21h-1.5v-.786a8.248 8.248 0 01-7.464-7.464H3v-1.5h.786a8.249 8.249 0 017.464-7.465V3h1.5v.785zM5.293 12.75a6.75 6.75 0 005.957 5.957v-3.032a3.754 3.754 0 01-2.925-2.925H5.293zm10.382 0a3.754 3.754 0 01-2.925 2.925v3.032a6.75 6.75 0 005.957-5.957h-3.032zm-5.794 0a2.25 2.25 0 001.369 1.368V12.75H9.88zm2.869 0v1.368a2.25 2.25 0 001.37-1.368h-1.37zm-1.5-7.458a6.75 6.75 0 00-5.957 5.958h3.032a3.755 3.755 0 012.925-2.926V5.292zm0 4.589a2.251 2.251 0 00-1.37 1.369h1.37V9.88zm1.5 1.369h1.37a2.251 2.251 0 00-1.37-1.37v1.37zm0-2.926a3.755 3.755 0 012.925 2.926h3.032a6.75 6.75 0 00-5.957-5.958v3.032z",
    fill: "currentColor"
  })));
}
SvgPokerGameTypeTotalKo.displayName = 'PokerGameTypeTotalKo';
export default SvgPokerGameTypeTotalKo;